import React from 'react';
import { Grid, Paper } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import CuestionarioSPTable from './CuestionarioSPTable';

export default function ListCuestionarioSP() {
  return (
    <DashboardLayout>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <CuestionarioSPTable />
        </Paper>
      </Grid>
    </DashboardLayout>
  );
}
